import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

/**
 * Reads the inbox_inquiry_groups flag for grouped inbox lists and grouped chat behavior.
 * Unrelated to anonymous fan-out on inquiry create, which the app now always requests.
 */
export function useGroupedInquiriesEnabled() {
  return useFeatureFlag(FEATURE_FLAGS.INBOX_INQUIRY_GROUPS);
}

/**
 * Anonymous routed inquiry grouping/display follows inbox grouping UI capability.
 * Submit fan-out is separate: the app always requests it for an anonymous inquiry.
 */
export function useAnonymousInquiryGroupingEnabled() {
  return useFeatureFlag(FEATURE_FLAGS.INBOX_INQUIRY_GROUPS);
}
